import React from 'react';
import { FormattedMessage } from 'react-intl';

const SuccessionDisclaimer = () => {
  return (
    <div className="bg-succession-warning-bg border border-succession-warning-border rounded-lg p-6">
      <div className="flex items-start">
        <div className="ml-3">
          <h4 className="text-lg font-medium text-succession-text-primary mb-2">
            <FormattedMessage id="calculators.cfa.disclaimer.title" defaultMessage="Important Disclaimer" />
          </h4>
          <div className="text-sm text-succession-text-primary space-y-2">
            <p>
              <FormattedMessage 
                id="calculators.cfa.disclaimer.general" 
                defaultMessage="This analysis is for informational purposes only and should not be considered as financial, tax, or legal advice. All projections and calculations are estimates based on the information provided and various assumptions." 
              />
            </p>
            <p>
              <FormattedMessage 
                id="calculators.cfa.disclaimer.accuracy" 
                defaultMessage="The accuracy of these projections depends on the accuracy of the input data and the validity of the underlying assumptions. Actual results may vary significantly from these projections due to changes in market conditions, regulatory environment, business performance, and other factors." 
              />
            </p>
            <p>
              <FormattedMessage 
                id="calculators.cfa.disclaimer.professional_advice" 
                defaultMessage="Before making any financial decisions based on this analysis, please consult with qualified financial, tax, and legal professionals who can provide advice tailored to your specific situation and circumstances." 
              />
            </p>
            <p className="font-medium">
              <FormattedMessage 
                id="calculators.cfa.disclaimer.no_guarantee" 
                defaultMessage="No guarantee is made regarding the accuracy, completeness, or reliability of the information presented. Use this analysis at your own discretion and risk." 
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessionDisclaimer; 